import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output"]

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length
    const max = this.inputTarget.getAttribute("maxlength")

    if (length === 0 || !max) {
      this.outputTarget.textContent = ""
    } else {
      this.outputTarget.textContent = `${length}/${max}`
    }
  }
}
